<template>
  <div class="architect2">
    <template v-if="from!='introDetail'">
    <div id="block"></div>
    <Header />
    <div class="box1"></div>
    </template>
    <div class="box2">
      <div class="btn" @click="zixun"></div>
    </div>
    <div class="box3"></div>
    <pageRightFloat pageName="Java工程师进阶课程-企业级核心框架-源码剖析"/>
    <Footer />
  </div>
</template>

<script>
import pageRightFloat from "../common/pageRightFloat.vue";
import Header from "../common/Header.vue";
import Footer from "../common/Footer.vue";
export default {
  name: 'architect2',
  components: {
    pageRightFloat,
    Header,
    Footer,
  },
   data() {
    return {from:''};
  },
  mounted() {
   this.from=this.getQueryString("from")
  },
  methods: {
    toLink() {
      window.open("https://m.boxuegu.com/");
    },
    zixun(name) {
      zhuge.track("H5_java工程师进阶专题页", {
        咨询按钮名称: name,
      });
      this.clickZiXun()
    },
  },
}
</script>

<style lang="scss" scoped>
.architect2{
  #block {
    width: 100%;
    height: 88px;
  }
  .box1{
    height: 2970px;
    background-image: url(../../../assets/coursePage/architect2/box1.png);
    background-size: 750px 2970px;
  }
  .box2{
    height: 1136px;
    background-image: url(../../../assets/coursePage/architect2/box2.png);
    background-size: 750px 1136px;
    position: relative;
    .btn{
      position: absolute;
      bottom: 88px;
      left: 50%;
      transform: translateX(-50%);
      width: 686px;
      height: 96px;
      background-image: url(../../../assets/coursePage/architect2/box2-btn.png);
      background-size: 686px 96px;
    }
  }
  .box3{
    height: 4690px;
    background-image: url(../../../assets/coursePage/architect2/box3.png);
    background-size: 750px 4690px;
  }
}
</style>